import { Card, Chip, Grid, Stack } from "@mui/material";
import SoftBox from "components/SoftBox";
import React from "react";
import PageLayout from "examples/LayoutContainers/PageLayout";
import dataTableData from "./components/data";
import DataTable from "./components/DataTable";
import SoftTypography from "components/SoftTypography";
import Loader from "examples/Loader";
import { useAppServices } from "hook/services";
import { useAgencyInfo } from "context/agency";

function Type() {
  const { data, processing, handleRefresh, main_data } = dataTableData();
  const AppService = useAppServices();
  const [agency] = useAgencyInfo();
  return (
    <PageLayout>
      {processing ? (
        <Loader />
      ) : (
        <Card
          sx={{
            boxShadow: "0 3px 5px 0 rgba(0,0,0,.06)",
            border: "1px solid #cfd7df",
            borderRadius: "8px",
            marginRight: "1em"
          }}
        >
          <SoftBox p={3}>
            <SoftTypography variant="h5">Location Users </SoftTypography>
          </SoftBox>
          <Grid container p={5} rowSpacing={3}>
            <Grid item xs={12}>
              <DataTable table={data} canSearch />
            </Grid>
          </Grid>
        </Card>
      )}
    </PageLayout>
  );
}

export default Type;
